// Fills the search popdown's "before typing" panel with sections/search-empty.liquid.
//
// The panel is fetched rather than rendered into the page because the popdown appears twice in
// every page's markup. The request starts on the first sign that search is about to be
// opened — pointer over or focus on its icon — so by the time the click lands it has usually
// arrived; the click itself also starts it, for touch. It is made once and shared by both
// popdowns, and only the one being opened gets the markup.
(function () {
  const HOLDER = '[data-search-empty]';
  const TRIGGER = 'header-search-popdown summary';

  let request = null;

  function load(url) {
    if (!request) {
      request = fetch(url, {credentials: 'same-origin'})
        .then((response) => (response.ok ? response.text() : ''))
        .catch(() => '')
        .then((html) => {
          // a failed attempt is not remembered, so the next open tries again
          if (!html) request = null;
          return html;
        });
    }
    return request;
  }

  function holderFor(element) {
    const popdown = element.closest('header-search-popdown');
    return popdown ? popdown.querySelector(HOLDER) : null;
  }

  function prefetch(event) {
    const trigger = event.target.closest && event.target.closest(TRIGGER);
    const holder = trigger && holderFor(trigger);
    if (holder) load(holder.getAttribute('data-search-empty'));
  }

  function fill(holder) {
    if (holder.hasAttribute('data-search-empty-filled')) return;
    load(holder.getAttribute('data-search-empty')).then((html) => {
      if (!html || holder.hasAttribute('data-search-empty-filled')) return;
      holder.innerHTML = html;
      holder.setAttribute('data-search-empty-filled', '');
    });
  }

  // The panel runs from under the search row to the bottom of the screen. Where that row ends is
  // only known once the popdown has finished sliding in, so it is measured then, and again on
  // resize.
  function fit(holder) {
    const top = holder.getBoundingClientRect().top;
    const height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    holder.style.setProperty('--search-empty-height', `${Math.max(0, height - top)}px`);
  }

  function fitWhenOpened(holder) {
    const popdown = holder.closest('[data-popdown]');
    const done = (event) => {
      if (event && event.target !== popdown) return;
      fit(holder);
    };
    if (popdown) popdown.addEventListener('transitionend', done);
    setTimeout(() => {
      if (popdown) popdown.removeEventListener('transitionend', done);
      fit(holder);
    }, 600);
  }

  window.addEventListener('resize', () => {
    document.querySelectorAll('details[open] ' + HOLDER).forEach(fit);
  });

  document.addEventListener('pointerover', prefetch, {passive: true});
  document.addEventListener('focusin', prefetch);

  // `toggle` does not bubble, so it is caught on the way down
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (details.tagName !== 'DETAILS' || !details.open) return;
      const holder = holderFor(details);
      if (!holder) return;
      fill(holder);
      fitWhenOpened(holder);
    },
    true
  );
})();
